module.exports = __webpack_public_path__ + "assets/img/all-order.e5be3f61.png";